export default "__VITE_ASSET__797f9a9c__"